export default function SVG_TextPath() {
  return (
    <div>
      <h1>SVG_TextPath Component</h1>
    </div>
  );
}
